import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Optional, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {avoidPassCharacters, calcLicenses, compareIds, copyTextClipboard, isNullOrUndefOrEmpty, validateCCNumber, validateEmail} from 'app/common';
import {UserSearch} from 'app/models';
import {faCcAmex, faCcDiscover, faCcMastercard, faCcPaypal, faCcVisa, faDropbox, faFacebook, faGoogleDrive, faGooglePlus, faHtml5, faInstagram, faLinkedin, faPaypal, faReddit, faTelegram, faTiktok, faTwitter, faVimeo, faYoutube} from "@fortawesome/free-brands-svg-icons";
import {ToastrService} from "ngx-toastr";
import {TranslocoService} from "@ngneat/transloco";
import {AppService, AuthUserService, StoreSelectorsService} from "../../../services";
import {faCalendar, faCode, faCreditCard, faMobileScreen, faQrcode, faShield, faShoppingCart} from "@fortawesome/free-solid-svg-icons";
import {EnumPricingMethod, ICartCreate, IOrderForm, IUser, IUserSaveDetailsReply, StringBinary, subscriptionPackages, TypePackages} from "../../../interfaces";
import {IAccountDetails} from "../../../interfaces/enterprise-account-interface";
import {debounceTime, distinctUntilChanged, take, tap} from "rxjs/operators";
import {
    actionUpdateAccountDetails,
    actionUserUpgradeFailed,
    actionUserUpgradeReply,
    actionUserUpgradeRequest
} from "../../../store/actions/user.actions";
import {actionEnterpriseUpdatedUserDetails} from "../../../store/actions/enterprise.actions";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {ofType} from "@ngrx/effects";
import {ActionsSubject} from "@ngrx/store";
import {Compbaser} from "../../../components/compbaser";
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {Lib} from "../../../../libs/Lib";
import * as _ from 'lodash';
import {timeout} from "../../../decorators/timeout";
import {MatStepHeader} from "@angular/material/stepper";
import {FintechService} from "../../../services/fintech.service";
import {switchMap} from "rxjs";
import {HttpClient} from "@angular/common/http";

type TypeCheckout = 'NEW_SUBSCRIBER' | 'UPDATE';

@Component({
    selector: 'app-wizard-upgrade',
    styleUrls: [`./wizard-upgrade.component.scss`],
    templateUrl: './wizard-upgrade.component.html'
})

export class WizardUpgradeComponent extends Compbaser implements OnInit, AfterViewInit {
    m_months = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    paymentType: 'cc' | 'pp' = 'cc';
    billingAsShipping: StringBinary;
    selectedPackage: TypePackages = 'plus';
    form: FormGroup;
    model: UserSearch;
    wizardMode: TypeCheckout;
    callback: (arg) => void | undefined;
    user: IUser;
    accountDetails: IAccountDetails;
    navigationEnd: NavigationEnd;
    dashboard: boolean;
    enterprise: boolean;
    cartCreate: ICartCreate;
    orderForm: IOrderForm;
    waitingUpgrade = false;
    disableUpdateButton = false;
    years = [];
    selectedStep = 0;
    modal = 1;
    licence: any = 0;
    licencesEnterprise: any = 0;
    licencesPlus: any = 0;
    MAX_SCREENS = 999;
    MAX_FREE_SCREENS = 3;
    PLUS_FLAT_PRICE = 3;
    m_viewOnly = false;
    m_movingFromPlusToEnterprise = false;
    m_showCompletedState = false;
    resellerUser: string;
    resellerPass: string;
    showCloseButton = true;
    selectedColorPlus: any = '';
    selectedColorEnterprise: any = '';
    selectedColorFree: any = '';
    stringJSPipeArgs = {toCurrency: ['us']};
    m_subscriptionPackages = subscriptionPackages;
    m_timer = 8;

    readonly faYouTube = faYoutube;
    readonly faQrcode = faQrcode;
    readonly faHtml5 = faHtml5;
    readonly faTwitter = faTwitter;
    readonly faShield = faShield;
    readonly faFacebook = faFacebook;
    readonly faCalendar = faCalendar;
    readonly faCode = faCode;
    readonly faMobileScreen = faMobileScreen;
    readonly faGoogleDrive = faGoogleDrive;
    readonly faDropbox = faDropbox;
    readonly faTiktok = faTiktok;
    readonly faVimeo = faVimeo;
    readonly faReddit = faReddit;
    readonly faInstagram = faInstagram;
    readonly faTelegram = faTelegram;
    readonly faGooglePlus = faGooglePlus;
    readonly faLinkedin = faLinkedin;
    readonly faCcVisa = faCcVisa;
    readonly faCcDiscover = faCcDiscover;
    readonly faPaypal = faPaypal;
    readonly faShoppingCart = faShoppingCart;
    readonly faCcPaypal = faCcPaypal;
    readonly faCreditCard = faCreditCard;

    ccIcons = [
        {
            type: 'MASTERCARD',
            cardType: '1',
            icon: faCcMastercard,
            selected: null
        },
        {
            type: 'DISCOVER',
            cardType: '2',
            icon: faCcDiscover,
            selected: null
        },
        {
            type: 'AMEX',
            cardType: '3',
            icon: faCcAmex,
            selected: null
        },
        {
            type: 'VISA',
            cardType: '0',
            icon: faCcVisa,
            selected: null
        },
    ];

    @ViewChild("paypalModal", {read: TemplateRef}) paypalModal: TemplateRef<any>;
    @ViewChild("creditCardModal", {read: TemplateRef}) creditCardModal: TemplateRef<any>;
    // @ViewChild('MatStepHeader', {static: false}) MatStepHeader: MatStepHeader;
    // @ViewChildren(MatStepHeader) stepHeaders: QueryList<MatStepHeader>;
    // @ViewChildren(MatStepHeader) stepHeaders: Array<ElementRef>;
    // @ViewChildren(MatStepHeader) stepHeaders: QueryList<ElementRef>;
    // @ViewChildren(MatStepHeader) stepHeaders: QueryList<ElementRef>;

    @ViewChildren(MatStepHeader) stepHeaders: QueryList<MatStepHeader> =
        undefined as unknown as QueryList<MatStepHeader>;


    @Input()
    set viewModeOnly(v: boolean) {
        this.m_viewOnly = v;
        this.showCloseButton = false;
    }

    constructor(dialog: MatDialog, private formBuilder: FormBuilder,
                private route: ActivatedRoute,
                private translocoService: TranslocoService, @Optional() @Inject(MAT_DIALOG_DATA) data: any,
                private storeSelector: StoreSelectorsService,
                private authService: AuthUserService,
                private renderer: Renderer2,
                private elementRef: ElementRef,
                private appService: AppService,
                private router: Router,
                private actionsSubj: ActionsSubject,
                private toastr: ToastrService,
                private http: HttpClient,
                public fintechService: FintechService) {

        super(dialog);



        this.setMe('wizard-upgrade.component.ts');
        if (data) {
            if (data.showCloseButton === false) {
                this.showCloseButton = false;
            }
            if (data.toast) {
                this.toastr.clear();
                if (this.m_viewOnly) return;
                switch (data.toast) {
                    case 1: {
                        this.toastr.error(this.translocoService.translate('general.pleaseUpgrade3', {}, this.translocoService.getActiveLang()), '', {
                            closeButton: true,
                            disableTimeOut: true,
                            tapToDismiss: false,
                            positionClass: 'toast-top-center'
                        });
                        break;
                    }
                    case 2: {
                        this.toastr.error(this.translocoService.translate('toast.reachedLimitOfFeature2', {}, this.translocoService.getActiveLang()), '', {
                            closeButton: true,
                            disableTimeOut: true,
                            tapToDismiss: false,
                            positionClass: 'toast-top-center'
                        });
                        break;
                    }
                }
            }
        }
        this.initYears();
        this.initForm();
        this.listenFormChanges();
    }

    ngOnInit(): void {
        if (this.route.snapshot.queryParams?.ent) {
            _.remove(subscriptionPackages, (pkg) => pkg === 'free');
            _.remove(subscriptionPackages, (pkg) => pkg === 'plus');
            this.onPackageSelected({value: 'enterprise'});
        }
        if (this.route?.snapshot?.data?.state && this.route?.snapshot?.data?.state === 'showCloseButton:false') {
            this.showCloseButton = false;
        }
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    if (this.m_viewOnly) return;
                    this.user = i_user;
                    if (Lib.GetAccountVersion(this.user) === 'FREE') {
                        this.selectedColorFree = 'warn';
                        this.wizardMode = "NEW_SUBSCRIBER";
                    } else if (Lib.GetAccountVersion(this.user) === 'PLUS') {
                        this.selectedColorPlus = 'warn';
                        this.wizardMode = "UPDATE";
                        this.hidePackages();
                    } else {
                        this.selectedColorEnterprise = 'warn';
                        this.wizardMode = "UPDATE";
                        this.hidePackages();
                    }
                    this.dashboard = this.user.dashboard;
                    this.enterprise = this.user.enterprise;
                    this.getUserDetails();
                    this.updateForm();
                    this.submitButtonState();
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionUserUpgradeReply))
                .subscribe((payload) => {
                    this.waitingUpgrade = false;
                    this.submitButtonState();
                    const reply: IUserSaveDetailsReply = payload.reply;
                    /** result is good, we CC passed **/
                    if (reply.result) {
                        /** show success dialog **/
                        this.m_showCompletedState = true;
                        if (reply.pricingMethod == 2) {
                            /** if we upgraded to plus don't show user/pass **/
                            this.onServerReplyUpdateStatus('plus');
                        } else if (reply.pricingMethod == 3) {
                            /** if we upgraded to enterprise show user/pass **/
                            this.onServerReplyUpdateStatus('enterprise', reply.resellerUser, reply.resellerPass);
                        }
                    } else {
                        let extra = '';
                        if (!isNullOrUndefOrEmpty(reply.error)) {
                            extra = reply.error;
                        }
                        return this.toastr.error('sorry, the upgrade failed... ' + extra, '', {closeButton: true, disableTimeOut: true, positionClass: 'toast-top-center'});
                    }
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionUserUpgradeFailed))
                .subscribe((payload) => {
                    this.waitingUpgrade = false;
                    this.submitButtonState();
                    this.messageErrorOccurred();
                })
        );
        this.cod(
            this.router.events
                .subscribe((e) => {
                    if (e instanceof NavigationEnd) {
                        this.navigationEnd = e;
                    }
                })
        );
        // this.cod(
        //     this.actionsSubj.pipe(ofType(actionDynawebsCheckUserSuccess))
        //         .subscribe((reply) => {
        //             this.waitingUpgrade = false;
        //             this.submitButtonState();
        //             if (reply.payload.businessId !== -1) {
        //                 // this.form.get('enterpriseUsername').patchValue('', {emitEvent: false});
        //                 return this.toastr.error(this.translocoService.translate('general.userExists', {}, this.translocoService.getActiveLang()), '', {
        //                     closeButton: true,
        //                     disableTimeOut: true,
        //                     tapToDismiss: false,
        //                     positionClass: 'toast-top-center'
        //                 });
        //             }
        //         })
        // );


        const obs$ = this.fintechService.getFintechInfo();
        this.cod(obs$.subscribe());

    }

    ngAfterViewInit() {
        if (this.m_viewOnly) {
            this.hideStepperHeader();
        }
    }

    enabledBack() {
        return this.fintechService.data != null && this.fintechService.editMode == 'info';
    }

    enabledNext() {
        if (this.wizardMode == 'UPDATE' && this.selectedPackage == 'plus') {
            return false;
        }
        return this.fintechService.data != null && this.fintechService.editMode == 'info';
    }

    hideStepperHeader() {
        const elementToHide = this.elementRef.nativeElement.querySelector('.mat-step-header');
        if (elementToHide) {
            this.renderer.setStyle(elementToHide, 'display', 'none');
        }
    }

    copyUserPass() {
        copyTextClipboard(`user: ${this.resellerUser} password: ${this.resellerPass}`);
        this.toastr.info(this.translocoService.translate('account.credCopied', {}, this.translocoService.getActiveLang()));
    }

    private submitButtonState() {
        if (this.waitingUpgrade)
            return this.disableUpdateButton = true;
        if (this.selectedPackage === 'free')
            return this.disableUpdateButton = true;
        if (this.selectedPackage === 'plus' && Lib.GetAccountVersion(this.user) === 'DASH')
            return this.disableUpdateButton = true;
        if ((Lib.GetAccountVersion(this.user) === 'ENTERPRISE_08' || Lib.GetAccountVersion(this.user) === 'ENTERPRISE_24') && Lib.IsResellerStatusActive(this.user))
            return this.disableUpdateButton = true;
        if ((Lib.GetAccountVersion(this.user) === 'DASH' || Lib.GetAccountVersion(this.user) === 'ENTERPRISE_08' || Lib.GetAccountVersion(this.user) === 'ENTERPRISE_24') && Lib.IsResellerStatusActive(this.user))
            return this.disableUpdateButton = true;
        return this.disableUpdateButton = false;
    }

    private hidePackages() {
        if ((Lib.GetAccountVersion(this.user) === 'PLUS')) {
            _.remove(subscriptionPackages, (pkg) => pkg === 'free');
            this.onPackageSelected({value: 'plus'});
        }
        if ((Lib.GetAccountVersion(this.user) === 'ENTERPRISE_08' || Lib.GetAccountVersion(this.user) === 'ENTERPRISE_24' || Lib.GetAccountVersion(this.user) === 'DASH')) {
            _.remove(subscriptionPackages, (pkg) => pkg === 'free');
            _.remove(subscriptionPackages, (pkg) => pkg === 'plus');
            this.onPackageSelected({value: 'enterprise'});
        }
    }

    private getUserDetails() {
        this.cod(
            this.storeSelector.getUserAccountDetails()
                .pipe(take(1))
                .subscribe((i_accountDetails: IAccountDetails) => {
                    this.accountDetails = _.cloneDeep(i_accountDetails);
                    this.updateForm();
                })
        );
    }

    private initForm() {
        this.form = this.formBuilder.group({
            status: ['', [Validators.required]],
            package: ['plus'],
            pricesScreen: ['3']
        });
    }

    private onServerReplyUpdateStatus(i_package: TypePackages, i_user = null, i_pass = null) {
        switch (i_package) {
            case 'plus': {
                setInterval(() => {
                    if (this.m_timer === 0) {
                        this.reloadStudio();
                    } else {
                        this.m_timer = this.m_timer - 1;
                    }
                }, 1000);
                break;
            }
            case 'enterprise': {
                this.resellerUser = i_user;
                this.resellerPass = i_pass;
                break;
            }
        }
    }

    private fillForm() {
        this.form.get('pricesScreen').patchValue(3, {emitEvent: false});

        switch (this.wizardMode) {
            case "UPDATE": {
                if (Lib.GetAccountVersion(this.user) === 'DASH') {
                    switch (this.selectedPackage) {
                        case 'free':
                        case 'plus': {
                            // this.form.get('enterpriseUsername').patchValue('----------', {emitEvent: false});
                            // this.form.get('enterpriseUsername').disable();
                            // this.setPasswordsHidden();
                            break;
                        }
                        case 'enterprise': {
                            // this.form.get('enterpriseUsername').patchValue(this.cleanField(this.user.username), {emitEvent: false});
                            // this.form.get('enterpriseUsername').disable();
                            // this.form.get('confirmPassword').patchValue('123123', {emitEvent: false});
                            // this.form.get('confirmPassword').disable();
                            // this.form.get('password').patchValue('123123', {emitEvent: false});
                            // this.form.get('confirmPassword').disable();
                            break;
                        }
                    }
                } else {
                    switch (this.selectedPackage) {
                        case 'free':
                        case 'plus': {
                            // this.form.get('enterpriseUsername').patchValue('----------', {emitEvent: false});
                            // this.form.get('enterpriseUsername').disable();
                            // this.setPasswordsHidden();
                            break;
                        }
                        case 'enterprise': {
                            // this.form.get('enterpriseUsername').patchValue('', {emitEvent: false});
                            // this.form.get('enterpriseUsername').enable();
                            // this.form.get('confirmPassword').patchValue('', {emitEvent: false});
                            // this.form.get('confirmPassword').enable();
                            // this.form.get('password').patchValue('', {emitEvent: false});
                            // this.form.get('password').enable();
                            break;
                        }
                    }
                }
                break;
            }
            case "NEW_SUBSCRIBER": {
                switch (this.selectedPackage) {
                    case 'free':
                    case 'plus': {
                        // this.form.get('enterpriseUsername').patchValue('----------', {emitEvent: false});
                        // this.form.get('enterpriseUsername').disable();
                        // this.setPasswordsHidden();
                        break;
                    }
                    case 'enterprise': {
                        // this.form.get('enterpriseUsername').patchValue('', {emitEvent: false});
                        // this.form.get('enterpriseUsername').enable();
                        // this.form.get('confirmPassword').patchValue('', {emitEvent: false});
                        // this.form.get('confirmPassword').enable();
                        // this.form.get('password').patchValue('', {emitEvent: false});
                        // this.form.get('password').enable();
                        break;
                    }
                }
            }
        }
        this.onCalcPrice();
    }

    // @timeout(100)
    // setPasswordsHidden() {
    //     this.form.get('confirmPassword').patchValue('password', {emitEvent: false});
    //     this.form.get('confirmPassword').disable();
    //     this.form.get('password').patchValue('password', {emitEvent: false});
    //     this.form.get('password').disable();
    // }

    private messageErrorOccurred() {
        this.toastr.info(this.translocoService.translate('toast.errorOccurred', {}, this.translocoService.getActiveLang()));
    }

    messageInvalidCharLogin(e) {
        this.toastr.info(this.translocoService.translate('toast.alphaNumeric', {}, this.translocoService.getActiveLang()));
    }

    messageInvalidCharChosen(e) {
        this.toastr.error(this.translocoService.translate('toast.pleaseAvoidChar', {}, this.translocoService.getActiveLang()) + avoidPassCharacters());
    }

    private cleanField(v) {
        if (!v || _.isUndefined(v) || v === 'undefined' || v === 'null' || _.isNull(v) || v === '') return '';
        return v;
    }

    forceValidation() {
        this.form.markAllAsTouched();
    }

    reloadStudio() {
        this.logout();
    }

    @timeout(333)
    logout() {
        this.authService.logout();
        this.appService.goToHomePage(false);
    }

    close() {
        this.dialog.closeAll();
    }

    private updateStore() {
        if (!this.accountDetails) return;
        if (this.form.invalid) return;
        const form = this.form.value;
        const accountDetailsNew = _.cloneDeep(this.accountDetails);
        if (this.dashboard) {
            this.storeSelector.dispatch(actionEnterpriseUpdatedUserDetails({userDetails: accountDetailsNew}));
        } else {
            // this.storeSelector.dispatch(actionCreateCredentials({
            //     createCredentials: {
            //         username: form.enterpriseUsername,
            //         password: form.password
            //     }
            // }));
            this.storeSelector.dispatch(actionUpdateAccountDetails({userDetails: accountDetailsNew}));
        }
    }

    onPackageSelected(e: { value: TypePackages }) {
        this.selectedPackage = e.value;
        this.updateForm();
        this.submitButtonState();
    }

    updateForm() {
        this.onCalcPrice();
        if (this.m_viewOnly) return;
        this.fillForm();
    }

    private listenFormChanges() {
        this.cod(
            this.form.valueChanges
                .pipe(
                    distinctUntilChanged((a, b) => {
                        return _.isEqual(a, b);
                    }), debounceTime(33))
                .subscribe((i_paymentForm: IOrderForm) => {
                    this.orderForm = i_paymentForm;
                    // this.onPaymentTypeChanged();
                    this.updateStore();
                })
        );
    }

    private initYears() {
        // const [createTimeStart, createTimeEnd]: string[] = splitTimeRange(this.model.createTimeRange, this.timeRangeSeparator);
        const thisYear = new Date().getFullYear() - 1;
        for (let i = 0; i < 15; i++)
            this.years.push(String(thisYear + i));
    }

    onCalcPrice() {
        this.form.get('pricesScreen').enable();
        let v = this.form.get('pricesScreen').value;
        if (isNullOrUndefOrEmpty(v)) return;
        if (v > this.MAX_SCREENS) {
            this.toastr.clear();
            const body = this.translocoService.translate('general.specialDiscount', {}, this.translocoService.getActiveLang());
            const title = this.translocoService.translate('general.letTalk', {}, this.translocoService.getActiveLang());
            this.toastr.info(body, title, {timeOut: 10000, positionClass: 'toast-top-full-width'});
            v = this.MAX_SCREENS;
            this.form.get('pricesScreen').patchValue(this.MAX_SCREENS, {emitEvent: false});
        }
        if (this.selectedPackage === 'free') {
            v = this.MAX_FREE_SCREENS;
            this.form.get('pricesScreen').patchValue(this.MAX_FREE_SCREENS, {emitEvent: false});
            this.form.get('pricesScreen').disable();
        }
        this.licencesPlus = Math.round(v * this.PLUS_FLAT_PRICE);
        const p = calcLicenses(v, null);
        this.licence = p.license;
        this.licencesEnterprise = p.licenses;
        if (p.licenses > this.MAX_SCREENS) {
            this.licencesEnterprise = Math.round(p.licenses);
        }
    }

    onCcChanged(e) {
        const type = this._detectCardType(e.target.value);
        this.ccIcons.forEach((card) => {
            card.type === type ? card.selected = true : card.selected = false;
        });
    }

    private _detectCardType(i_value): string {
        i_value = i_value.replace(/\s+/g, '');
        const re = {
            electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
            maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
            dankort: /^(5019)\d+$/,
            interpayment: /^(636)\d+$/,
            unionpay: /^(62|88)\d+$/,
            visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
            mastercard: /^5|2[1-5][0-9]{14}$/,
            amex: /^3[47][0-9]{13}$/,
            diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
            discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
            jcb: /^(?:2131|1800|35\d{3})\d{11}$/
        };
        if (re.electron.test(i_value)) {
            return 'ELECTRON';
        } else if (re.maestro.test(i_value)) {
            return 'MAESTRO';
        } else if (re.dankort.test(i_value)) {
            return 'DANKORT';
        } else if (re.interpayment.test(i_value)) {
            return 'INTERPAYMENT';
        } else if (re.unionpay.test(i_value)) {
            return 'UNIONPAY';
        } else if (re.visa.test(i_value)) {
            return 'VISA';
        } else if (re.mastercard.test(i_value)) {
            return 'MASTERCARD';
        } else if (re.amex.test(i_value)) {
            return 'AMEX';
        } else if (re.diners.test(i_value)) {
            return 'DINERS';
        } else if (re.discover.test(i_value)) {
            return 'DISCOVER';
        } else if (re.jcb.test(i_value)) {
            return 'JCB';
        } else {
            return undefined;
        }
    }

    submit(e: Event) {
        e.preventDefault();
    }

    private getPriceMethodNumber(i_selectedPackage: string): EnumPricingMethod {
        if (i_selectedPackage === 'plus') {
            return EnumPricingMethod.PLUS;
        }
        /** for now not using | if this is an old 2008 enterprise account and just updating CC we do not switch to ENTERPRISE_24  **/
        // if (compareIds(this.user.pricingMethod, EnumPricingMethod.ENTERPRISE_08)) {
        //     return EnumPricingMethod.ENTERPRISE_08;
        // }
        if (i_selectedPackage === 'enterprise') {
            return EnumPricingMethod.ENTERPRISE_24;
        }
    }

    onSubmitForm(event: Event, typeCheckout: TypeCheckout) {
        this.waitingUpgrade = true;
        this.submitButtonState();
        const form: IOrderForm = _.cloneDeep(this.orderForm);
        form.pricingMethod = this.getPriceMethodNumber(this.selectedPackage);

        switch (typeCheckout) {

            case "UPDATE": {
                /** if plus we bypass customer and get his reseller id which exists in the billing token because in plus payment_id is same for reseller / user **/
                if (Lib.GetAccountVersion(this.user) === "PLUS") {
                    form.billingToken = this.user.billingToken;
                }
                if (compareIds(this.user.pricingMethod, EnumPricingMethod.PLUS) && this.selectedPackage === 'enterprise') {
                    this.toastr.info(this.translocoService.translate('account.upgPlus', {}, this.translocoService.getActiveLang()));
                    this.m_movingFromPlusToEnterprise = true;
                }
                /** Update customer details, will get charged now if inactive, or on next pay period if active **/

                // ??? this.storeSelector.dispatch(actionResubscribeRequest({payload: form})); // ???

                const obs$ = this.fintechService.getPayerToken().pipe(
                        switchMap( payerToken => {
                            const url = "https://galaxy.signage.me/Web/resubscribeAccount.ashx";
                            const options = {
                                token: payerToken,
                                pricingMethod: form.pricingMethod
                            };
                            return this.http.post(url, options);
                        })
                    );

                obs$.subscribe((res) => {
                    if ((<any>res).result) {
                        /** show success dialog **/
                        this.m_showCompletedState = true;
                        this.onServerReplyUpdateStatus('enterprise', (<any>res).resellerUser, (<any>res).resellerPass);
                    }
                });
                break;
            }

            case "NEW_SUBSCRIBER": {
                /** Upgrade customer info, we will charge him now for this month's subscription **/
                this.storeSelector.dispatch(actionUserUpgradeRequest({payload: form}));
                break;
            }
        }
        event.stopImmediatePropagation();
        event.preventDefault();
    }

    onStepChange(e: StepperSelectionEvent) {
        this.selectedStep = e.selectedIndex;
        // if (this.selectedStep > 2 && !this.dashboard) {
        //     this.checkUsername();
        // }
    }
}

// this.toastr.info('please re-login to the SignStudio to enjoy your new features', 'update completed', {
//     closeButton: true,
//     disableTimeOut: true,
//     tapToDismiss: false,
//     positionClass: 'toast-top-center'
// });

// switch (this.m_movingFromPlusToEnterprise) {
//     // case EnumUpdatingToNewPackage.FREE_ENTERPRISE: {
//     //     this.onServerReplyUpdateStatus('enterprise', reply.payload.resellerUser, reply.payload.resellerPass);
//     //     this.m_showCompletedState = true;
//     //     break;
//     // }
//     // case EnumUpdatingToNewPackage.FREE_PLUS: {
//     //     this.onServerReplyUpdateStatus('plus');
//     //     this.m_showCompletedState = true;
//     //     break;
//     // }
//     // case EnumUpdatingToNewPackage.PLUS_ENTERPRISE: {
//     //     this.onServerReplyUpdateStatus('enterprise', reply.payload.resellerUser, reply.payload.resellerPass);
//     //     this.m_showCompletedState = true;
//     //     break;
//     // }
//     // case EnumUpdatingToNewPackage.ENTERPRISE_PLUS: {
//     //     this.onServerReplyUpdateStatus('plus');
//     //     this.m_showCompletedState = true;
//     //     break;
//     // }
//
// }
// enum EnumUpdatingToNewPackage {
//     EMPTY,
//     PLUS_ENTERPRISE,
//     ENTERPRISE_PLUS
// }
// if (this.selectedPackage === 'plus' && compareIds(this.user.pricingMethod, EnumPricingMethod.FREE)) {
//     this.toastr.info('Upgrading from Free to Plus...');
//     this.m_movingNewPackage = EnumUpdatingToNewPackage.FREE_PLUS;
// }
// if (this.selectedPackage === 'plus' && (compareIds(this.user.pricingMethod, EnumPricingMethod.ENTERPRISE_08) || (compareIds(this.user.pricingMethod, EnumPricingMethod.ENTERPRISE_24)))) {
//     this.toastr.info('Downgrading from Enterprise+ to Plus edition...');
//     this.m_movingNewPackage = EnumUpdatingToNewPackage.ENTERPRISE_PLUS;
// }
// private checkUsername() {
//     if (this.selectedPackage === 'plus') {
//         return;
//     }
//     if (this.selectedStep < 2) return;
//     const user = this.form.get('enterpriseUsername').value;
//     if (user.length === 0) return;
//     this.storeSelector.dispatch(actionDynawebsCheckUser({user}));
//     this.waitingUpgrade = true;
//     this.submitButtonState();
// }
